import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si no sé absolutamente nada de electricidad?',
  a: 'Sí. El Tomo 1 arranca desde cero absoluto con el Protocolo Cero Riesgo antes de cualquier acción.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% PDF. Acceso por email en menos de 5 minutos después del pago.'
}, {
  q: '¿Funciona para casas viejas y departamentos nuevos?',
  a: 'Sí. El sistema cubre instalaciones desde los años 80 hasta las más modernas.'
}, {
  q: '¿Qué lo diferencia de buscar videos en YouTube?',
  a: 'Orden correcto, normativa argentina (IRAM/AEA), protocolo de seguridad previo y sistema completo — no información dispersa.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días, 100% de devolución. Escribís a soportebibliotecasdigitales@gmail.com y en menos de 24 horas está resuelto.'
}, {
  q: '¿Necesito herramientas especiales?',
  a: 'El Bono 3 te guía exactamente qué comprar. El kit mínimo sale menos de $35.000 en una sola compra de ferretería.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 bg-petroleum/30 border-y border-white/5" data-id="element-104">
      <div className="container mx-auto px-4" data-id="element-105">
        <div className="text-center mb-8" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-bold flex items-center justify-center gap-3" data-id="element-107">
            <span className="text-2xl" data-id="element-108">❓</span> LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-109">
          {faqs.map((faq, i) => <div key={i} className="bg-graphite border border-white/10 rounded-xl overflow-hidden" data-id="element-110">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left hover:bg-white/5 transition-colors" data-id="element-111">
                <span className="font-medium pr-8" data-id="element-112">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-113">
                  <ChevronDown className="w-5 h-5 text-textsecondary shrink-0" data-id="element-114" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-115">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-116">
                    <div className="p-5 pt-0 text-textsecondary border-t border-white/5" data-id="element-117">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}